import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SurveyPageComponent } from "./survey-page/survey-page.component";

const routes: Routes = [
  {
    path: ":administrativeUnitSurveyId",
    data: { title: "Surveys", allowed: [true, true] },
    component: SurveyPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SurveysRoutingModule {}
